<template>
  <section class="form-limited-width">
    <base-form-group
      :label="$t('personInfo.1701')"
      :is-invalid="$v.localUser.login.$error"
      :errors="{
        required: !$v.localUser.login.required,
        loginExist: !$v.localUser.login.notIn
      }"
      :messages="{
        loginExist: $t('src/pages/registration.2195')
      }"
      class="position-relative"
    >
      <div class="d-flex">
        <base-input
          v-if="isOwner || isCreate"
          :is-invalid="$v.localUser.login.$error"
          v-model="localUser.login"
          name="login"
          @blur="$v.localUser.login.$touch()"
        >
        </base-input>
        <h6 v-else>
          {{ localUser.login }}
        </h6>
        <svg-icon
          v-if="isNeuroAdmin && isCreate"
          :name="'generate'"
          @click:icon="generateLogin"
          class="svg-icon-middle ml-3 mt-2"
          :width="28"
          :title="$t('src/pages/login.getLogin')"
        ></svg-icon>
      </div>
    </base-form-group>
    <base-form-group
      :label="$t('personInfo.role')"
      :is-invalid="$v.localUser.user_roles.$error"
      :errors="{
        required: !$v.localUser.user_roles.required
      }"
    >
      <user-roles-select
        :is-invalid="$v.localUser.user_roles.$error"
        v-model="localUser.user_roles"
      ></user-roles-select>
    </base-form-group>
    <base-form-group
      :label="$t('personInfo.3508')"
      :is-invalid="$v.localUser.surname.$error"
      :errors="{
        required: !$v.localUser.surname.required,
        allowSymbols: !$v.localUser.surname.allowSymbols
      }"
    >
      <base-input
        :is-invalid="$v.localUser.surname.$error"
        v-model="localUser.surname"
        name="surname"
        :disabled="!isEditAllow"
        @blur="$v.localUser.surname.$touch()"
      >
      </base-input>
    </base-form-group>
    <base-form-group
      :label="$t('personInfo.2678')"
      :is-invalid="$v.localUser.name.$error"
      :errors="{
        required: !$v.localUser.name.required,
        allowSymbols: !$v.localUser.name.allowSymbols
      }"
    >
      <base-input
        :is-invalid="$v.localUser.name.$error"
        v-model="localUser.name"
        name="name"
        :disabled="!isEditAllow"
        @blur="$v.localUser.name.$touch()"
      >
      </base-input>
    </base-form-group>
    <base-form-group
      :label="$t('personInfo.547')"
      :is-invalid="$v.localUser.middle_name.$error"
      :errors="{
        allowSymbols: !$v.localUser.name.allowSymbols
      }"
    >
      <base-input
        :is-invalid="$v.localUser.middle_name.$error"
        v-model="localUser.middle_name"
        name="middleName"
        :disabled="!isEditAllow"
        @blur="$v.localUser.middle_name.$touch()"
      >
      </base-input>
    </base-form-group>
    <base-form-group
      :label="$t('personInfo.email')"
      :is-invalid="$v.localUser.email.$error"
      :errors="{
        likeEmail: !$v.localUser.email.likeEmail,
        emailOverlong: !$v.localUser.email.emailOverlong,
        required: !$v.localUser.email.required
      }"
    >
      <base-input
        :is-invalid="$v.localUser.email.$error"
        v-model="localUser.email"
        name="email"
        :disabled="!isEditAllow"
        @blur="$v.localUser.email.$touch()"
      >
      </base-input>
    </base-form-group>
    <base-form-group
      :label="$t('personInfo.phone')"
      :is-invalid="$v.localUser.phone.$error"
      :errors="{
        likePhone: !$v.localUser.phone.likePhone,
        phoneOverlong: !$v.localUser.phone.phoneOverlong
      }"
    >
      <base-input
        :is-invalid="$v.localUser.phone.$error"
        v-model="localUser.phone"
        name="phone"
        type="tel"
        :disabled="!isEditAllow"
        @blur="$v.localUser.phone.$touch()"
      >
      </base-input>
    </base-form-group>
    <base-form-group
      :label="$t('personInfo.department')"
      :is-invalid="$v.localUser.department.$error"
      :errors="{
        allowSymbols: !$v.localUser.department.allowSymbols
      }"
    >
      <base-input
        :is-invalid="$v.localUser.department.$error"
        v-model="localUser.department"
        name="department"
        :disabled="!isEditAllow"
        @blur="$v.localUser.department.$touch()"
      >
      </base-input>
    </base-form-group>
    <base-form-group
      :label="$t('personInfo.position')"
      :is-invalid="$v.localUser.position.$error"
      :errors="{
        allowSymbols: !$v.localUser.position.allowSymbols
      }"
    >
      <base-input
        :is-invalid="$v.localUser.position.$error"
        v-model="localUser.position"
        name="position"
        :disabled="!isEditAllow"
        @blur="$v.localUser.position.$touch()"
      >
      </base-input>
    </base-form-group>
    <base-form-group :label="$t('personInfo.3298')">
      <h6 v-if="hasNoRightsToChangeStatus" class="form-text">
        {{ statusList[localUser.status].title }}
      </h6>
      <base-dropdown-select
        v-else
        :options="statusList"
        v-model="localUser.status"
        class="form-control"
      ></base-dropdown-select>
    </base-form-group>
    <button type="button" class="btn btn-primary mt-3" @click="submit">
      <span v-if="saving" class="spinner-border spinner-border-sm"></span>{{ $t('button.save') }}
    </button>
  </section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { notIn, allowSymbols, likePhone, phoneOverlong, likeEmail, emailOverlong } from '@/modules/validators'
import { userRights } from '@/mixins/user-rights'
import { userStatusList } from '@/modules/status-list.js'
import { userStatus } from '@/main.config.js'
import http from '@/modules/http.js'
import { stringify } from 'qs'

export default {
  name: 'UserForm',
  components: {
    UserRolesSelect: () => import('@/components/UserRolesSelect.vue'),
    BaseFormGroup: () => import('@/base/BaseFormGroup.vue'),
    BaseInput: () => import('@/base/BaseInput.vue'),
    BaseDropdownSelect: () => import('@/base/BaseDropdownSelect.vue'),
    SvgIcon: () => import('@/components/SvgIcon.vue')
  },
  mixins: [userRights],
  model: {
    prop: 'user'
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    excludedLogins: {
      type: Array,
      default() {
        return []
      }
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    localUser: null,
    localExcludedLogins: null
  }),
  validations() {
    return {
      localUser: {
        login: {
          required,
          notIn: value => notIn(value, this.excludedLogins)
        },
        user_roles: {
          required
        },
        surname: {
          required,
          allowSymbols
        },
        name: {
          required,
          allowSymbols
        },
        middle_name: {
          allowSymbols
        },
        phone: {
          likePhone,
          phoneOverlong
        },
        email: {
          required,
          likeEmail,
          emailOverlong
        },
        department: {
          allowSymbols
        },
        position: {
          allowSymbols
        }
      }
    }
  },
  computed: {
    statusList() {
      return userStatusList
    },
    authUserId() {
      return this.$store.getters.AUTH_USER.id
    },
    isCreate() {
      return this.user.createdAt === undefined
    },
    isOwner() {
      return this.user.id && this.user.id === this.authUserId
    },
    isEditAllow() {
      return this.isCreate || this.isOwner || this.isAnyAdmin
    },
    hasNoRightsToChangeStatus() {
      return !this.isAnyAdmin || this.user.status === userStatus.unregistered
    }
  },
  watch: {
    localUser: {
      deep: true,
      handler() {
        this.$emit('input', this.localUser)
      }
    },
    excludedLogins() {
      this.$v.localUser.login.$touch()
    }
  },
  created() {
    this.localUser = Object.assign({}, this.user)
    this.loadUser().then(data => {
      this.localExcludedLogins = Object.assign(this.excludedLogins, data)
    })
  },

  methods: {
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('submit')
        this.$v.$reset()
      }
    },
    generateLogin() {
      let str
      let tempStr = ''
      do {
        str = Math.floor(Math.random() * 100000)
          .toString()
          .padStart(5, '0')
        tempStr = this.localExcludedLogins.find(val => val === str)
      } while (tempStr !== undefined)
      this.localUser.login = `admin_${str}`
      this.$v.localUser.login.$touch()
    },
    loadUser() {
      let params = {
        login: { $like: `%admin_%` }
      }
      return new Promise(resolve => {
        http
          .get('/users', {
            params: params,
            paramsSerializer: params =>
              stringify(params, {
                arrayFormat: 'indices',
                encodeValuesOnly: true
              })
          })
          .then(response => response.data)
          .then(data => {
            resolve(data.data.map(user => user.login))
          })
          .catch(error => console.log(error))
      })
    }
  }
}
</script>
